export default "__VITE_ASSET__DwQaCk0J__"